import React from 'react'
import Layout from '../../components/Layout/layout'
import { Box } from '@material-ui/core'

const DashboardQuicksight = () => {
  return <Layout title="Reporte de operaciones">
    <Box display="flex" justifyContent="center">
      <iframe
        width="100%"
        height="800"
        src="https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/271551172366/dashboards/b3ae8698-4e8b-456e-a188-23a895be95ef?directory_alias=ingeniolaunion-qs">
      </iframe>
    </Box>
  </Layout>
}

export default DashboardQuicksight
